import { computed, ref, Ref } from 'vue';
import { ComplexModal } from '@studyportals/modal';
import { ModalErrorState, ModalErrorStateType } from '@/models/modal.interface';
import store from '@/store';

export default class ErrorModalCode {
	public modalContent: Ref<HTMLElement | null> = ref(null);
	private modal: Ref<ComplexModal | undefined> = ref(undefined);

	public errorIsRelatedToRetrieveDashboards = computed((): boolean => {
		return this.modalErrorState.value === ModalErrorState.RETRIEVE_DASHBOARDS;
	});

	public errorIsRelatedToRetrieveJWT = computed((): boolean => {
		return this.modalErrorState.value === ModalErrorState.RETRIEVE_JWT;
	});

	public errorIsRelatedToRetrieveJWTInstanceId = computed((): boolean => {
		return this.modalErrorState.value === ModalErrorState.RETRIEVE_JWT_INSTANCE_ID;
	});

	private modalErrorState = computed((): ModalErrorStateType => {
		return store.getters.modalErrorState();
	});

	public mounted(): void {
		this.prepareModal();
	}

	public unmounted(): void {
		window.ModalManager.close(this.modal.value);
	}

	private prepareModal(): void {
		if (!this.modalContent.value) {
			return;
		}

		this.modal.value = new ComplexModal(this.modalContent.value, {
			cssClassName: 'ErrorModalWrapper',
			destroyOnClose: false,
			onClose: this.closeModalAndRefreshPage.bind(this)
		});

		window.ModalManager.open(this.modal.value);
	}
	
	private closeModalAndRefreshPage(): void {
		store.mutations.setModalErrorState(ModalErrorState.INACTIVE)
		window.location.reload();
	}
}
